const asArray = (value) => (Array.isArray(value) ? value : []);

const normalizeText = (value) => (
    typeof value === 'string' ? value.trim().toLowerCase() : ''
);

const LESSON_DOCUMENT_TYPES = new Set([
    'lesson',
    'lesson_plan',
    'saved_lesson',
]);

const getDocumentType = (document = {}) => normalizeText(
    document.doc_type ||
    document.document_type ||
    document.type ||
    document.category
);

const getDocumentIdentity = (document = {}) => (
    document.id ||
    document.document_id ||
    document.uuid ||
    [document.title, document.created_at, document.updated_at]
        .map((part) => (typeof part === 'string' ? part.trim() : ''))
        .filter(Boolean)
        .join('|')
);

export const isSavedLessonDocument = (document = {}) => {
    const documentType = getDocumentType(document);

    if (documentType) {
        return LESSON_DOCUMENT_TYPES.has(documentType);
    }

    const metadata = document.metadata || {};

    return Boolean(
        metadata.lesson_id ||
        metadata.lesson_date ||
        metadata.lesson_data
    );
};

export const getSavedLessonDocuments = (documents = []) => {
    const seen = new Set();

    return asArray(documents).filter(isSavedLessonDocument).filter((document) => {
        const identity = getDocumentIdentity(document);
        if (!identity) return true;
        if (seen.has(identity)) return false;
        seen.add(identity);
        return true;
    });
};
